export default __webpack_public_path__ + "static/media/homepage_icon.ee06a78b.svg";